import { CardContent } from "@mui/material";
import Highcharts from "highcharts";
import { PaxElementWrapper, PaxElementWrapperProps } from "@ncino/pax-ui";
import { PaxChart } from "./PaxChart";
import { useEffect, useRef } from "react";
import { HighchartsReactRefObject } from "highcharts-react-official";
// this is the PaxChart wrapped in a card element

interface PaxChartElementProps {
  readonly options: Highcharts.Options;
}

export function PaxChartElement(props: PaxChartElementProps & PaxElementWrapperProps) {
  const chartRef = useRef<HighchartsReactRefObject>(null);

  // Sometimes charts won't render properly in reports due to
  // a sudden container size change after its loading state disappears.
  // So, trigger a redraw to adjust chart dimensions with its container size.
  useEffect(() => {
    if (chartRef.current == null) {
      return;
    }
    chartRef.current.chart.redraw();
  }, []);

  return (
    <PaxElementWrapper {...props}>
      <CardContent>
        <PaxChart options={props.options} chartRef={chartRef} />
      </CardContent>
    </PaxElementWrapper>
  );
}
